module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-447.fd6a8abd.jpg";